import React from 'react';
import {graphql} from 'react-apollo';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import gql from 'graphql-tag';
import messages from 'App/util/common/messages';

import {
  selectors as socketSel,
  actions as socketActions
} from 'App/util/redux/socket/index';

import {
  selectors as storageSel,
  actions as storageActions
} from 'App/util/redux/storage/index';

import {selectors as authSel} from 'App/util/redux/auth';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
} from 'reactstrap';
import ExportDropDown from './ExportDropdown';
import {renderForError, renderWhileLoading} from 'App/util/recompose/graphql';


const {wsListen, wsUnlisten} = socketActions;

// get redux store
const mapStateToProps = (state) => ({
  user: authSel.user(state),
  listener: socketSel.listener(state),
  generating: storageSel.generating(state),
});

const mapDispatchToProps = (dispatch) => ({
  wsListen: (key, subject, cb) => dispatch(wsListen(key, subject, cb)),
  wsUnlisten: (key, subject) => dispatch(wsUnlisten(key, subject)),
  setStorage: (key, value) => dispatch(storageActions.set(key, value)),
});

@compose(
  graphql(
    gql `
      mutation($type:String!, $name:String!, $scope:String!) {
        generate_export(type:$type, name:$name, scope:$scope)
      }
    `,
    { name: 'export' }
  ),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  graphql(
    gql `
      query($where: Export_Where) {
        exports(where: $where) {
          export_id
          name
          type
          scope
        }
      }
    `,
    {
      options: (props) => ({ variables: { where: { user_id: { eq: props.user.user_id } } } })
    }),
  renderWhileLoading(),
  renderForError()
)
export default class PatientExport extends React.Component {
  constructor(props) {
    super(props);

    this.listenerSubject = 'PatientExport';

    this.state = {currentOption: 'null'};

    this.props.wsListen('export',
      this.listenerSubject,
      (payload) => {
        // this.setState({generating: false});
        this.props.wsUnlisten('export', this.listenerSubject);
        this.props.setStorage('generating', false);

        messages.success('Patient export file successfully generated.');

        // redirect to file
        window.location = window.location.origin + '/' + payload.file;
      }
    );
  }

  isGenerating() {
    return (this.props.listener['export'] !== undefined &&
      this.props.listener['export'][this.listenerSubject] !== undefined);
  }

  dropDownChanged(e) {
    this.setState({ currentOption: e.target.value.split('_') });
  }

  generate() {
    if (this.state.currentOption != 'null') {
      const name = this.state.currentOption[0];
      const type = this.state.currentOption[1];
      const scope = this.state.currentOption[2];

      messages.alert(
        'Generating the xls file',
        `The file will be generated now and you will be notified as soon as it is ready.
       Your browser will download it automatically. This will take some time!<br>
       <b>Do not close the application or the browser window!</b>`);

      this.props.setStorage('generating', true);
      this.props.export({ variables: { type: type, scope: scope, name: name } });
    } else
      messages.alert('Please select an export type!')
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.props.data.exports.length > 0 &&
        <Card>
          <CardHeader>Patient Export</CardHeader>
          <CardBody>
            Please select the export you'd like to generate:
            <ExportDropDown onChange={(e) => this.dropDownChanged(e)}
                            exports={this.props.data.exports} />
          </CardBody>
          <CardFooter>
            <Button disabled={this.props.generating} onClick={() => this.generate()}>
              {this.props.generating ? ' ..currently generating file' : 'create new export'}
            </Button>
          </CardFooter>
        </Card>
        ||
        <Alert color="danger">
          <h4 className="alert-heading">access denied</h4>
          <hr />
          <p>your account is not activated for any file export</p>
        </Alert>}
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/views/Patient/Export/Export.js